import { Component, OnInit, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { InsertionPlanChoiceService } from 'src/app/collections/inspection-plan-assistant/insertion-plan-choice.service';
import { IWindow } from '@phdsoft/window';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { AutomaticPoints } from 'src/app/automatic-points/_models/AutomaticPoints';
import { InspectionApplied } from 'src/app/automatic-points/_models/InspectionApplied';
import { GeneralSettings } from "src/app/automatic-points/_models/GeneralSettings"
import { StiffenersSettings } from "src/app/automatic-points/_models/StiffenersSettings"
import { FacePlatesSettings } from "src/app/automatic-points/_models/FacePlatesSettings"
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InspectionRegion } from "src/app/automatic-points/_models/InspectionRegion";
import { InspectionSession } from "src/app/automatic-points/_models/InspectionSession";
import { PlatesPointCriteria } from "src/app/automatic-points/_models/PlatesPointCriteria";
import { PlatesSettings } from "src/app/automatic-points/_models/PlatesSettings";
import { PointsArrangements } from "src/app/automatic-points/_models/PointsArrangements";
import { BracketSettings } from "src/app/automatic-points/_models/BracketSettings"
import { IAutomaticPointPreset } from '../_models/AutomaticPointPreset';
import { AutomaticPointPresetService } from './automatic-point-preset.service';
import { StorageService, User } from '@phdsoft/common';
import { SESSION_STORAGE, Util } from '@phdsoft/common';
import { environment } from 'src/environments/environment';
import { SignalRService } from 'src/app/signalr/signalr';
import { HttpClient } from '@angular/common/http';
import { v4 as uuid } from 'uuid';
import { AssetManager } from 'src/app/asset-manager/asset-manager';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClusterService } from 'src/app/cluster/cluster.service';
import { ElementResultInfo } from 'projects/phdsoft/common/src/lib/models/element-result-info.model';
import { AssetInfoViewService } from 'src/app/template/asset-info-view/asset-info-view/asset-info-view.service';
import { ClusterElementViewModel } from 'projects/phdsoft/common/src/lib/models/cluster-element.model';
import { ClusterState } from 'src/app/cluster/cluster.state';
import { IAutomaticPlanTypeSelectorData } from '../automatic-plan-type-selector/automatic-plan-type-selector.component';
import { INSPECTIONS_TYPES_IDS } from 'projects/phdsoft/common/src/lib/shared/constants/inspections-types-ids';
import { ISideboard } from '@app/side-board/ISideboard';
import { TemplateService } from '@app/template/template.service';

interface CIGPWData {
  AssetId: any,
  regions: any
  regionsIds: any
  sectionIds: any
  sectionNames: any
  automatiPlanTypeSelectorData: IAutomaticPlanTypeSelectorData
}


@Component({
  selector: 'phdsoft-collection-inspection-gaugins-positioning-wizard',
  templateUrl: './collection-inspection-gaugins-positioning-wizard.component.html',
  styleUrls: ['./collection-inspection-gaugins-positioning-wizard.component.scss']
})
export class CollectionInspectionGauginsPositioningWizardComponent implements OnInit, OnChanges {
  /** Where the day is in several open plans, which one the new points go to. */
  private readonly insertionPlanChoice = inject(InsertionPlanChoiceService);

  @Input() automatiPlanTypeSelectorData: IAutomaticPlanTypeSelectorData;
  
  _AutomaticPoints: AutomaticPoints;
  PointsArrangements = PointsArrangements; // Expose enum to template
  currentRegionIds: any[]
  isOnLinesSelected: boolean = false;
  selectedElementIds: string[] = [];

  // Preset management
  presets: IAutomaticPointPreset[] = [];
  selectedPreset: IAutomaticPointPreset | null = null;
  isLoadingPresets = false;
  isSavingPreset = false;
  showCreatePresetDialog = false;
  showRenamePresetDialog = false;
  newPresetName = '';
  presetToRename: IAutomaticPointPreset | null = null;
  presetToDelete: IAutomaticPointPreset | null = null;

  Lst_InspectionApplied: InspectionApplied[] = [
    { name: "2ND Plataform Deck 14040 a/B BL (Engine Room)", id: 1, checked: true },
    { name: "Frame 7 (Stem)", id: 2, checked: true },
    { name: "Frame 5 (Stem)", id: 3, checked: false },
    { name: "Frame 4 (Stem)", id: 3, checked: true },
  ];

  Lst_InspectionAppliedPlates: InspectionApplied[] = [
    { name: "1.00", id: 1, checked: true },
    { name: "1.50", id: 2, checked: true },
    { name: "5.00", id: 4, checked: false },
    { name: "15.00", id: 6, checked: false },
    { name: "30.00", id: 8, checked: false },
    { name: "45.00", id: 10, checked: false }
  ];

  Lst_InspectionAppliedStiffeners: InspectionApplied[] = [
    { name: "1.00", id: 1, checked: true },
    { name: "1.50", id: 2, checked: true },
    { name: "5.00", id: 4, checked: false },
    { name: "15.00", id: 6, checked: false },
    { name: "30.00", id: 8, checked: false },
    { name: "45.00", id: 10, checked: false }
  ];

  Lst_InspectionAppliedFacePlates: InspectionApplied[] = [
    { name: "1.00", id: 1, checked: true },
    { name: "1.50", id: 2, checked: true },
    { name: "5.00", id: 4, checked: false },
    { name: "15.00", id: 6, checked: false },
    { name: "30.00", id: 8, checked: false },
    { name: "45.00", id: 10, checked: false }
  ];

  Lst_InspectionAppliedBrackets: InspectionApplied[] = [
    { name: "1.00", id: 1, checked: true },
    { name: "1.50", id: 2, checked: true },
    { name: "5.00", id: 4, checked: false },
    { name: "15.00", id: 6, checked: false },
    { name: "30.00", id: 8, checked: false },
    { name: "45.00", id: 10, checked: false }
  ];

  name1: String = "Teste";
  name2: String = "Teste2";

  LotRegion: boolean = true;

  LotSection: boolean = true;


  form: FormGroup;
  FormSession1FacePlates: FormGroup;

  optionsWindow: ISideboard = {
    VisibleMini: true,
    VisibleClose: true,
    Header: {
      VisibleTitle: true,
      Title: 'Automatic - Gaugins Positioning Wizard'
    },
    Footer: {
      ShowOk: true,
      ShowCancel:false,
      Visible: true,
    }
  };

  responsiveOptions;
  
  data: CIGPWData

  constructor(
    private fb: FormBuilder,
    public signalRService: SignalRService,
    public clusterService: ClusterService,
    public clusterState: ClusterState,
    public assetManager: AssetManager,
    public assetInfoViewService: AssetInfoViewService,
    private readonly storageService: StorageService,
    private snackBar: MatSnackBar,
    private readonly http: HttpClient,
    private templateService: TemplateService,
    private automaticPointPresetService: AutomaticPointPresetService
  ) {
    this.assetInfoViewService.castCurrentRegionIds.subscribe((data) => {
      this.currentRegionIds = data
    })
  }

  setupData() {
    const AssedId = this.assetManager.asset.assetInfo.AssetId;

    const hasSomeChecked = this.assetManager.asset.GetStructureVisibleRegions().some(x => x.visible);

    const regions = this.assetManager.asset.GetStructureVisibleRegions().filter(x => hasSomeChecked ? x.visible :
      x.sections.some(y => y.visible && y.group.parent.visible)).map(x => {
        if (!x.Guid) return
        const hasSomeSectionChecked = x.sections.some(y => y.visible);

        return [x.Guid, x.Name, x.sections.filter(y => hasSomeSectionChecked ? y.visible : y.visible).map(y => [
          y.Guid, y.Name
        ]),
        ]
      });

    const regionsIds = this.assetManager.asset.GetStructureVisibleRegions()
      .filter((x) => x.visible)
      .flatMap((y) => y.Guid)
    const sectionIds = this.assetManager.asset.GetStructureVisibleRegions().map(y => y.sections
      .filter((x) => x.visible)
      .flatMap((x) => x.Guid))
    const sectionNames = this.assetManager.asset.GetStructureVisibleRegions().map(y => y.sections
      .filter((x) => x.visible)
      .flatMap((x) => x.Name))

    this.data = {
      AssetId: AssedId,
      regions: regions,
      regionsIds: regionsIds,
      sectionIds: sectionIds,
      sectionNames: sectionNames,
      automatiPlanTypeSelectorData: this.automatiPlanTypeSelectorData
    }
  }

  isShown: boolean = false;
  isButtonOpen: boolean = true;

  pageIndex: number = 0

  toggleShow() {
    this.isShown = !this.isShown;
    this.isButtonOpen = !this.isButtonOpen;
    this.initializeComponentData();
    this.snackBar.open('Select the Region and click on "Next" to set up the Plates, Stiffeners and Brackets settings.', '', {
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      duration: 8000
    });
  }

  initializeComponentData() {
    this._AutomaticPoints = new AutomaticPoints();
    this._AutomaticPoints.Id = null;
    this._AutomaticPoints.AssetId = this.data.AssetId;
    this._AutomaticPoints.CollectionId = null;
    this._AutomaticPoints.Label = "AutomaticPoints";
    
    // Check if automatiPlanTypeSelectorData is available
    if (this.automatiPlanTypeSelectorData) {
      this._AutomaticPoints.InspectionTypeId = this.automatiPlanTypeSelectorData.inspectionTypeId;
      this._AutomaticPoints.InspectionMethodId = this.automatiPlanTypeSelectorData.inspectionMethodId;
      this._AutomaticPoints.InspectionTypeName = this.automatiPlanTypeSelectorData.inspectionTypeName;
      this._AutomaticPoints.InspectionTypeAlias = this.assetManager.listInpectionType?.find(t => t.id === this.automatiPlanTypeSelectorData.inspectionTypeId)?.alias;
      this._AutomaticPoints.CheckLists = this.automatiPlanTypeSelectorData.checkLists;
    } else {
      console.warn('automatiPlanTypeSelectorData is not available');
    }

    //#region "GENERAL SETTINGS"
    this._AutomaticPoints.GeneralSettings = new GeneralSettings();
    this._AutomaticPoints.GeneralSettings.CurrentPage = true;
    this._AutomaticPoints.GeneralSettings.AllPages = false;
    this._AutomaticPoints.GeneralSettings.BulkheadsNoStifffners = true;
    this._AutomaticPoints.GeneralSettings.DeleteOldAutomaticPoints = false;
    this._AutomaticPoints.GeneralSettings.Date = moment(this.assetManager.referenceDate).format("yyyy-MM-DD")

    this._AutomaticPoints.GeneralSettings.Regions = [];
    this._AutomaticPoints.GeneralSettings.ElementIds = [];


    for (let i = 0; i <= this.data.regions.length - 1; i++) {
      let _Lst_SectionIds = [];

      var _ItemRegions = new InspectionRegion();
      _ItemRegions.RegionId = this.data.regions[i][0];
      _ItemRegions.SectionIds = this.data.regions[i][2].map(x => x[0]);
      _ItemRegions.RegionName = this.data.regions[i][1];
      _ItemRegions.RegionChecked = !Util.isNullOrUndefined(this.data.regionsIds.find(x => x === this.data.regions[i][0]));
      if (!this.isShown) {
        _ItemRegions.RegionChecked = true;
      }



      var _Info_Session = new InspectionSession();
      _ItemRegions.Sections = [];

      for (let j = 0; j <= this.data.regions[i][2].length - 1; j++) {
        const sectionInfo = {
          SectionId: this.data.regions[i][2][j][0], SectionName: this.data.regions[i][2][j][1],
          SectionChecked: !Util.isNullOrUndefined(this.data.sectionIds.find(x => x === this.data.regions[i][2][j][0]))
        }
        if (!this.isShown) {
          sectionInfo.SectionChecked = true;
        }

        _Lst_SectionIds.push(this.data.regions[i][2][j][0]);

        _ItemRegions.Sections.push(sectionInfo);
      }

      if (this.isShown) {
        this._AutomaticPoints.GeneralSettings.Regions.push(this.tranform(_ItemRegions));
      } else {
        this._AutomaticPoints.GeneralSettings.Regions.push(_ItemRegions);
      }
    }
    //#endregion

    //#region  : PLATES

    this._AutomaticPoints.PlatesSettings = new PlatesSettings();
    this._AutomaticPoints.PlatesSettings.PositionGaugingsforPlates = true;
    this._AutomaticPoints.PlatesSettings.PositionGaugingsforBays = false
    this._AutomaticPoints.PlatesSettings.PositionGaugingsforCriticalAreas = false;
    this._AutomaticPoints.PlatesSettings.CriticalAreaThreshold = 0
    this._AutomaticPoints.PlatesSettings.PositionGaugingsforAnomalies = false;
    this._AutomaticPoints.PlatesSettings.AnomaliesThreshold = 0

    let _PlatesPointCriteria: PlatesPointCriteria[] = [
      { Area: 0.09, NumberOfPoints: 1, AddCenterPoint: true, NumberOfRows: 0  },
      { Area: 0.50, NumberOfPoints: 2, AddCenterPoint: true, NumberOfRows: 0 },
      { Area: 1.00, NumberOfPoints: 4, AddCenterPoint: true, NumberOfRows: 0 },
      { Area: null, NumberOfPoints: null, AddCenterPoint: false, NumberOfRows: 0 },
      { Area: null, NumberOfPoints: null, AddCenterPoint: false, NumberOfRows: 0 },
      { Area: null, NumberOfPoints: null, AddCenterPoint: false, NumberOfRows: 0 }
    ];

    this._AutomaticPoints.PlatesSettings.PositionPointCriteriaList = [];
    this._AutomaticPoints.PlatesSettings.PositionPointCriteriaList = _PlatesPointCriteria;
    this._AutomaticPoints.PlatesSettings.MinimumDistanceBetweenPoints = 0.5;
    this._AutomaticPoints.PlatesSettings.MinimumDistanceFromEdges = 0.12;
    this._AutomaticPoints.PlatesSettings.MinimumDistanceFromElements = 0.05;
    this._AutomaticPoints.PlatesSettings.PointsArrangements = PointsArrangements.Pattern;

    //#endregion

    //#region : "STIFFENERS"

    this._AutomaticPoints.StiffenersSettings = new StiffenersSettings();

    this._AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnStiffeners = true;
    this._AutomaticPoints.StiffenersSettings.PositionGaugingPointsOnBays = false;
    this._AutomaticPoints.StiffenersSettings.InsertPointsOnWeb = true;
    this._AutomaticPoints.StiffenersSettings.InsertPointsOnFlange = true;
    this._AutomaticPoints.StiffenersSettings.PositionGaugingsforCriticalAreas = false;
    this._AutomaticPoints.StiffenersSettings.CriticalAreaThreshold = 0
    this._AutomaticPoints.StiffenersSettings.PositionPointCriteriaList = [
      { Length: 0.9, NumberOfPoints: 1 },
      { Length: 4, NumberOfPoints: 2 },
      { Length: 12, NumberOfPoints: 3 },
      { Length: null, NumberOfPoints: null },
      { Length: null, NumberOfPoints: null },
      { Length: null, NumberOfPoints: null }
    ];

    //#endregion

    //#region "FACE PLATES"

    this._AutomaticPoints.FacePlatesSettings = new FacePlatesSettings();
    this._AutomaticPoints.FacePlatesSettings.PositionGaugingPointsOnFacePlates = true;
    this._AutomaticPoints.FacePlatesSettings.PositionGaugingPointsOnBays = false;
    this._AutomaticPoints.FacePlatesSettings.PositionGaugingsforCriticalAreas = false;
    this._AutomaticPoints.FacePlatesSettings.CriticalAreaThreshold = 0
    this._AutomaticPoints.FacePlatesSettings.PositionPointCriteriaList = [
      { Length: 0.01, NumberOfPoints: 1 },
      { Length: 5, NumberOfPoints: 3 },
      { Length: null, NumberOfPoints: null },
      { Length: null, NumberOfPoints: null },
      { Length: null, NumberOfPoints: null },
      { Length: null, NumberOfPoints: null }
    ];

    //#endregion


    //#region "BRACKETS"

    this._AutomaticPoints.BracketSettings = new BracketSettings();
    this._AutomaticPoints.BracketSettings.PositionGaugingPointsOnBrackets = true;
    this._AutomaticPoints.BracketSettings.PositionGaugingPointsOnBays = false;
    this._AutomaticPoints.BracketSettings.PositionGaugingsforCriticalAreas = false;
    this._AutomaticPoints.BracketSettings.CriticalAreaThreshold = 0
    this._AutomaticPoints.BracketSettings.PositionPointCriteriaList = [
      { Area: 0.5, NumberOfPointsWeb: 1, NumberOfPointsFlange: 1 },
      { Area: 5, NumberOfPointsWeb: 3, NumberOfPointsFlange: 3 },
      { Area: 10, NumberOfPointsWeb: 4, NumberOfPointsFlange: 4 },
      { Area: null, NumberOfPointsWeb: null, NumberOfPointsFlange: null }
    ];
    this._AutomaticPoints.BracketSettings.PointsArrangement = PointsArrangements.DescendingDiagonal;

    //#endregion
  }


  tranform = (region) => ({
    name: region.RegionName,
    id: region.RegionId,
    selected: false,
    parentId: '',
    item: '',
    children: region.Sections.map(y => ({ name: y.SectionName, parentId: region.RegionId, selected: false, id: y.SectionId }))
  })

  transformBack = (region) => ({
    SectionIds: region.SectionIds,
    RegionName: region.name,
    RegionId: region.id,
    RegionChecked: region.selected,
    ElementIds: region.elementIds || [],
    Sections: region.children.map(x => ({ SectionName: x.name, SectionId: x.id, SectionChecked: x.selected }))

  })

  ngOnInit() {
    this.form = this.fb.group({
      role: []
    });

    this.FormSession1FacePlates = this.fb.group({
      role: []
    });

    // Setup data and initialize if we have the input data
    if (this.automatiPlanTypeSelectorData) {
      this.setupData();
      this.initializeComponentData();
      this.loadPresets();
    }

    this.toggleShow()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.automatiPlanTypeSelectorData && changes.automatiPlanTypeSelectorData.currentValue) {
      // Update data and re-initialize when input changes
      this.setupData();
      this.initializeComponentData();
    }
  }

  private filterEmptyValues(values) {
    const indexesToRemove = []
    let index = 0;
    for (const iterator of values) {
      if (Util.isNullOrUndefined(iterator.NumberOfPoints)) {
        indexesToRemove.push(index);
      }
      index++;
    }

    for (let i = indexesToRemove.length - 1; i >= 0; i--) {
      values.splice(indexesToRemove[i], 1);
    }
    return values;
  }

  private filterEmptyValuesBrackets(values) {
    const indexesToRemove = []
    let index = 0;
    for (const iterator of values) {
      if (Util.isNullOrUndefined(iterator.NumberOfPointsWeb)) {
        indexesToRemove.push(index);
      }
      index++;
    }

    for (let i = indexesToRemove.length - 1; i >= 0; i--) {
      values.splice(indexesToRemove[i], 1);
    }
    return values;
  }

  async submit() {

    this._AutomaticPoints.PlatesSettings.PositionPointCriteriaList = this.filterEmptyValues(this._AutomaticPoints.PlatesSettings.PositionPointCriteriaList);
    this._AutomaticPoints.StiffenersSettings.PositionPointCriteriaList = this.filterEmptyValues(this._AutomaticPoints.StiffenersSettings.PositionPointCriteriaList);
    this._AutomaticPoints.FacePlatesSettings.PositionPointCriteriaList = this.filterEmptyValues(this._AutomaticPoints.FacePlatesSettings.PositionPointCriteriaList);
    this._AutomaticPoints.BracketSettings.PositionPointCriteriaList = this.filterEmptyValuesBrackets(this._AutomaticPoints.BracketSettings.PositionPointCriteriaList);

    const autoPoints = JSON.parse(JSON.stringify(this._AutomaticPoints)) as AutomaticPoints;
    autoPoints.Date = this.assetManager.referenceDate;
    if (this.isShown) {
      const checkedRegions = []

      for (const region of autoPoints.GeneralSettings.Regions) {
        // Sections are already pre-filtered by region-selection component
        if (region.children && region.children.length > 0) {
          region.SectionIds = region.children.map(x => x.id);
          checkedRegions.push(this.transformBack(region));
        }
      }
      autoPoints.GeneralSettings.Regions = checkedRegions;
    }

    const user = await this.storageService.getItem<any>(SESSION_STORAGE.USER) as User
    autoPoints.UserId = user.id
    autoPoints.CollectionId = uuid().replace(/-/g, '') as string;

    // Add selected ElementIds to the request
    autoPoints.GeneralSettings.ElementIds = this.selectedElementIds;

    if (!(await this.insertionPlanChoice.prepareBotRequest(autoPoints))) return;

    let _response = await this.http.post<any>(
      environment.API_INSPEC + 'UtmPoints/signalrutmautomaticinspectionpoints',
      autoPoints
    ).toPromise();

    let elementToRegenerate = <ElementResultInfo>{};
    let elementToRegenerateArray = <ElementResultInfo[]>{};
    let checklist = <any>{};
    checklist.Date = autoPoints.Date;
    elementToRegenerate.AssetId = autoPoints.AssetId;
    elementToRegenerate.RegionIds = [];
    var ids: any[];
    ids = autoPoints.GeneralSettings.Regions.map(x => x.RegionId);
    ids.forEach(x =>
      elementToRegenerate.RegionIds.push(x)
    )

    elementToRegenerate.CheckList = [];
    elementToRegenerate.CheckList.push(checklist)
    elementToRegenerateArray = [];
    elementToRegenerateArray.push(elementToRegenerate)
    const data: Array<ClusterElementViewModel> = new Array<ClusterElementViewModel>();
    for (const iterator of elementToRegenerateArray) {
      let datesFromChecklist = iterator.CheckList.map(x => x.Date)
      let uniqueDatesFromChecklist: any[] = [...new Set(datesFromChecklist)]

      let datesFromChecklistNotClusterized: any[] = []
      if (this.clusterState.ClusterState.items.length == 0) {
        datesFromChecklistNotClusterized = datesFromChecklistNotClusterized.concat(uniqueDatesFromChecklist)
      } else {
        uniqueDatesFromChecklist.forEach(dateFromChecklist => {
          let test = this.clusterState.ClusterState.items.find(item =>
            // TODO change this inspectionTypeId hardcoded later
            item.date === dateFromChecklist && item.typeId === INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING
          )
          if (test == undefined) {
            datesFromChecklistNotClusterized.push(dateFromChecklist)
          }
        })
      }
      datesFromChecklistNotClusterized = [...new Set(datesFromChecklistNotClusterized)]
      if (datesFromChecklistNotClusterized.length > 0) {
        // TODO change this inspectionTypeId hardcoded later
        data.push({ ClusterType: "Inspection", AssetId: autoPoints.AssetId, RegionIds: ids, Dates: uniqueDatesFromChecklist, InspectionTypeId: INSPECTIONS_TYPES_IDS.THICKNESS_GAUGING });
      }
    }
    console.log(this.clusterState.ClusterState);

    if (data.length > 0) {
      // Cluster regeneration with UTM is activated in the backend
      // this.clusterService.RegenerateClustersIfNeeded(data).toPromise();
    }

    for (const iterator of elementToRegenerateArray) {
      let datesFromChecklist = iterator.CheckList.map(x => x.Date)
      let uniqueDatesFromChecklist: any[] = [...new Set(datesFromChecklist)]
      uniqueDatesFromChecklist.forEach(x => {
        this.clusterState.checkClusterState({ date: x, typeId: iterator.InspectionTypeId })
      })
    }

    console.log(_response);
  };

  Execute() {
    this.closeWindow();
  }

  closeWindow() {
    this.templateService.toggleCollectionInspectionGauginsPositioningWizard(false)
  }


  //#region "CHECKBOX CONTROL CHECKED - PLATES BY SESSION STRUCTURE"

  _FacePlates_Session1_Chk1Changed(checked) {
    this._AutomaticPoints.FacePlatesSettings.PositionGaugingPointsOnBays = false;
  }

  _FacePlates_Session1_Chk2Changed(checked) {
    this._AutomaticPoints.FacePlatesSettings.PositionGaugingPointsOnFacePlates = false;
  }

  //#endregion


  //#region "CHECKBOX CONTROL CHECKED - PLATES BY SESSION STRUCTURE"

  onPlatesArrangementChange(arrangement: PointsArrangements) {
    this.isOnLinesSelected = arrangement === PointsArrangements.OnLines;
    
    if (this.isOnLinesSelected) {
      this.setAddCenterPointToFalse(false);
    } else {
      this.setNumberOfRowToZero();
      if (arrangement !== PointsArrangements.Linear) {
        this.setAddCenterPointToFalse(true);
      }
    }
  }

  setNumberOfRowToZero() {
    if (this._AutomaticPoints?.PlatesSettings?.PositionPointCriteriaList) {
      this._AutomaticPoints.PlatesSettings.PositionPointCriteriaList.forEach(criteria => {
        criteria.NumberOfRows = 0;
      });
    }
  }

  setAddCenterPointToFalse(v:boolean) {
    if (this._AutomaticPoints?.PlatesSettings?.PositionPointCriteriaList) {
      this._AutomaticPoints.PlatesSettings.PositionPointCriteriaList.forEach(criteria => {
        criteria.AddCenterPoint = v;
      });
    }
  }
  //#endregion

  //#region "CHECKBOX CONTROL CHECKED - BRACKET  BY SESSION STRUCTURE"
  // Bracket arrangement is now handled by two-way binding in the template
  //#endregion

  onSelectRegion({ regionId }) {

    this._AutomaticPoints.GeneralSettings.Regions.forEach(element => {

      if (element.id === regionId) {

        var selected = !element.selected

        element.selected = selected

        element.children.forEach(s => {

          s.selected = selected

        });
      }
    });
  }

  onSelectSection({ regionId, sectionId }) {

    this._AutomaticPoints.GeneralSettings.Regions.forEach(element => {

      if (element.id === regionId) {

        element.children.forEach(s => {

          if (s.id === sectionId) {
            s.selected = !Boolean(s.selected)
          }

        })

      }

    });
  }

  onSelectedElementIds(elementIds: string[]) {
    this.selectedElementIds = elementIds;
  }

  onSelectedRegionsData(regionsData: any[]) {
    this._AutomaticPoints.GeneralSettings.Regions = regionsData;
  }



  //#endregion

  //#region "PRESET MANAGEMENT"

  loadPresets(): void {
    this.isLoadingPresets = true;
    const assetId = this.assetManager.asset.assetInfo.AssetId;

    this.automaticPointPresetService.getByAssetId(assetId).subscribe({
      next: (presets) => {
        this.presets = presets;
        // Select default preset if none selected
        if (!this.selectedPreset) {
          this.selectedPreset = presets.find(p => p.isDefault) || presets[0];
          if (this.selectedPreset) {
            this.applyPreset(this.selectedPreset);
          }
        }
        this.isLoadingPresets = false;
      },
      error: (error) => {
        console.error('Error loading presets:', error);
        this.isLoadingPresets = false;
      }
    });
  }

  selectPreset(preset: IAutomaticPointPreset): void {
    this.selectedPreset = preset;
    this.applyPreset(preset);
  }

  applyPreset(preset: IAutomaticPointPreset): void {
    // Deep copy settings from preset to avoid reference issues
    this._AutomaticPoints.PlatesSettings = JSON.parse(JSON.stringify(preset.platesSettings));
    this._AutomaticPoints.StiffenersSettings = JSON.parse(JSON.stringify(preset.stiffenersSettings));
    this._AutomaticPoints.FacePlatesSettings = JSON.parse(JSON.stringify(preset.facePlatesSettings));
    this._AutomaticPoints.BracketSettings = JSON.parse(JSON.stringify(preset.bracketSettings));

    // Update isOnLinesSelected based on the loaded preset
    this.isOnLinesSelected = this._AutomaticPoints.PlatesSettings.PointsArrangements === PointsArrangements.OnLines;
  }

  saveAsNewPreset(): void {
    if (!this.newPresetName.trim()) return;

    this.isSavingPreset = true;
    const assetId = this.assetManager.asset.assetInfo.AssetId;

    this.automaticPointPresetService.createPresetFromCurrentSettings(
      assetId,
      this.newPresetName,
      this._AutomaticPoints.PlatesSettings,
      this._AutomaticPoints.StiffenersSettings,
      this._AutomaticPoints.FacePlatesSettings,
      this._AutomaticPoints.BracketSettings
    ).subscribe({
      next: (newPreset) => {
        this.presets.push(newPreset);
        this.selectedPreset = newPreset;
        this.showCreatePresetDialog = false;
        this.newPresetName = '';
        this.isSavingPreset = false;
        this.snackBar.open('Preset saved successfully', '', { duration: 3000 });
      },
      error: (error) => {
        console.error('Error saving preset:', error);
        this.isSavingPreset = false;
        this.snackBar.open('Error saving preset', '', { duration: 3000 });
      }
    });
  }

  updateCurrentPreset(): void {
    if (!this.selectedPreset || this.selectedPreset.isDefault) return;

    this.isSavingPreset = true;
    const updatedPreset = {
      ...this.selectedPreset,
      platesSettings: this._AutomaticPoints.PlatesSettings,
      stiffenersSettings: this._AutomaticPoints.StiffenersSettings,
      facePlatesSettings: this._AutomaticPoints.FacePlatesSettings,
      bracketSettings: this._AutomaticPoints.BracketSettings
    };
    this.automaticPointPresetService.update(updatedPreset).subscribe({
      next: (updated) => {
        if (updated) {
          const index = this.presets.findIndex(p => p.id === updated.id);
          if (index !== -1) {
            this.presets[index] = updated;
          }
          this.snackBar.open('Preset updated successfully', '', { duration: 3000 });
        }
        this.isSavingPreset = false;
      },
      error: (error) => {
        console.error('Error updating preset:', error);
        this.isSavingPreset = false;
        this.snackBar.open('Error updating preset', '', { duration: 3000 });
      }
    });
  }

  renamePreset(): void {
    if (!this.newPresetName.trim() || !this.presetToRename || this.presetToRename.isDefault) return;

    this.isSavingPreset = true;
    const updatedPreset = { ...this.presetToRename, name: this.newPresetName };
    this.automaticPointPresetService.update(updatedPreset).subscribe({
      next: (updated) => {
        if (updated) {
          const index = this.presets.findIndex(p => p.id === updated.id);
          if (index !== -1) {
            this.presets[index] = updated;
          }
          this.presetToRename = null;
          this.newPresetName = '';
          this.snackBar.open('Preset renamed successfully', '', { duration: 3000 });
        }
        this.isSavingPreset = false;
      },
      error: (error) => {
        console.error('Error renaming preset:', error);
        this.isSavingPreset = false;
        this.snackBar.open('Error renaming preset', '', { duration: 3000 });
      }
    });
  }

  deletePreset(preset: IAutomaticPointPreset): void {
    if (preset.isDefault) {
      this.snackBar.open('Cannot delete default preset', '', { duration: 3000 });
      return;
    }

    this.isSavingPreset = true;
    this.automaticPointPresetService.delete(preset.id).subscribe({
      next: () => {
        this.presets = this.presets.filter(p => p.id !== preset.id);
        if (this.selectedPreset?.id === preset.id) {
          this.selectedPreset = this.presets.find(p => p.isDefault) || this.presets[0];
          if (this.selectedPreset) {
            this.applyPreset(this.selectedPreset);
          }
        }
        this.isSavingPreset = false;
        this.snackBar.open('Preset deleted successfully', '', { duration: 3000 });
      },
      error: (error) => {
        console.error('Error deleting preset:', error);
        this.isSavingPreset = false;
        this.snackBar.open('Error deleting preset', '', { duration: 3000 });
      }
    });
  }

  openCreatePresetDialog(): void {
    this.newPresetName = '';
    this.showCreatePresetDialog = true;
  }

  openRenamePresetDialog(preset: IAutomaticPointPreset): void {
    this.presetToRename = preset;
    this.newPresetName = preset.name;
  }

  cancelCreatePreset(): void {
    this.showCreatePresetDialog = false;
    this.newPresetName = '';
  }

  cancelRenamePreset(): void {
    this.presetToRename = null;
    this.newPresetName = '';
  }

  openDeletePresetDialog(preset: IAutomaticPointPreset): void {
    this.presetToDelete = preset;
  }

  confirmDeletePreset(): void {
    if (!this.presetToDelete) return;
    this.deletePreset(this.presetToDelete);
    this.presetToDelete = null;
  }

  cancelDeletePreset(): void {
    this.presetToDelete = null;
  }

  //#endregion

  back() {
    this.pageIndex--

    if (this.pageIndex < 0) this.pageIndex = 0
  }

  next() {
    this.pageIndex++

    if (this.pageIndex > 5) this.pageIndex = 0
  }
}
